module.exports = __webpack_public_path__ + "media/Video 106.1f202916.mp4";